import React from 'react'
import logo1 from '../../StudentRegristrationDesign/jain logo.png'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const Header = () => {
  const userdata = JSON.parse(sessionStorage.getItem('userdata')) || {}
  const { f_name, m_name, l_name } = userdata

  const navigate = useNavigate()

  const logoutFun = () => {
    const confirmLogout = window.confirm('Are you sure you want to logout?')
    if (confirmLogout) {
      sessionStorage.clear()
      navigate('/')
    }
  }

  return (
    <>
      <Row
        className="py-3 m-0 p-0"
        style={{
          alignItems: 'center',
          backgroundColor: '#0783d6',
          color: 'white',
        }}
      >
        {/* LEFT SIDE — BOARDING NAME */}
        <Col
          xs={12}
          md={7}
          className="text-center text-md-start"
        >
          {/* MOBILE LOGO */}
          <div className="d-md-none mb-2">
            <img
              src={logo1}
              alt="Logo"
             style={{ height: '90px',backgroundColor:"#a2d6f8",borderRadius:"50%" }}
            />
          </div>

          {/* BOARDING NAME */}
          <span
            style={{
              fontSize: '20px',
              fontWeight: '500',
              lineHeight: '1.3',
            }}
          >
            Sheth R. D. Davada Digambar Jain Boarding, Sangli.
          </span>
        </Col>

        {/* RIGHT SIDE — USER INFO */}
        <Col
          xs={12}
          md={5}
          className="text-center text-md-end mt-2 mt-md-0"
        >
          <span style={{ fontSize: '18px' }}>
            Hi, {f_name} {m_name} {l_name}
          </span>
        </Col>
      </Row>
    </>
  )
}

export default Header
